import { Fragment } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { HR } from 'foundations-components/transitional/components/HR';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { SLADetailsRow } from '../_internal/components/SLADetailsRow';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { usePausedTimeLeft } from '../_internal/hooks/usePausedTimeLeft';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TOOLTIP_MIN_INLINE_SIZE = '300px';
// Exported only for unit testing purposes
export const SLATooltipContent = ({
  pausedTicketStatus,
  slas,
  ticketId
}) => {
  const {
    allSLAData,
    loading
  } = usePausedTimeLeft({
    slas,
    ticketId
  });
  // There is data if at least one of the properties is not null
  const hasSomeData = Object.values(allSLAData || {}).some(sla => !!sla.dueDate);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      minInlineSize: TOOLTIP_MIN_INLINE_SIZE,
      children: [/*#__PURE__*/_jsxs(Text, {
        typography: "detail-100",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.slaStatus"
        }), /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.statusHeaders.paused"
          })
        })]
      }), /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        typography: "detail-100",
        children: pausedTicketStatus
      })]
    }), loading && /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.loadingSpinnerLabel"
      }),
      layout: "centered"
    }), hasSomeData && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(HR, {
        distance: "xs"
      }), Object.values(allSLAData || {}).map(sla => /*#__PURE__*/_jsx(SLADetailsRow, {
        isPausedSLA: sla.isPaused,
        slaDetails: sla
      }, sla.category))]
    })]
  });
};
export const SLAPausedDetailsTooltip = ({
  children,
  pausedTicketStatus,
  slas,
  ticketId
}) => {
  const TooltipContent = () => /*#__PURE__*/_jsx(SLATooltipContent, {
    pausedTicketStatus: pausedTicketStatus,
    slas: slas,
    ticketId: ticketId
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    Content: TooltipContent,
    maxInlineSize: "600px",
    minInlineSize: TOOLTIP_MIN_INLINE_SIZE,
    placement: "bottom",
    use: "longform",
    children: /*#__PURE__*/_jsx("span", {
      children: children
    })
  });
};
SLAPausedDetailsTooltip.displayName = 'SLAPausedDetailsTooltip';